import { DialogActions, DialogContent } from '@material-ui/core';
// eslint-disable-next-line no-restricted-imports
import React, { FC } from 'react';
import { Dialog, DialogTitle } from '../common/Dialog';
import { CancelButton } from './CancelButton';
import { ConfirmButton } from './ConfirmButton';
import { useLicenseAssignment } from './LicenseAssignmentContext';

export const LicenseAssignmentModal: FC = ({ children }) => {
  const { toggleModal, licenseId, modalActive } = useLicenseAssignment();

  return (
    <Dialog onClose={toggleModal} open={modalActive}>
      <DialogTitle>Assign Users to License {licenseId}</DialogTitle>
      <DialogContent>{children}</DialogContent>
      <DialogActions>
        <CancelButton />
        <ConfirmButton />
      </DialogActions>
    </Dialog>
  );
};
